(function ($, Drupal)  {

  var iframes = document.querySelectorAll('.js-rfp-iframe iframe');
  
  // Set ration from inital load
  iframes.forEach(function(iframe){
    var ratio = iframe.width / iframe.height ;
    iframe.setAttribute('data-ratio', ratio);
  });

  var resizeIframes = function () {
    iframes.forEach(function(iframe){
      var width = iframe.parentElement.clientWidth;
      iframe.width = width;
      iframe.height = width / (iframe.dataset.ratio);
    });
  };

  window.addEventListener('resize', resizeIframes );
  resizeIframes();


}(jQuery, Drupal));